
<header>
  <div class="d-flex">
    <h3 class="title">
        <fa-icon [icon]="['fas', 'shopping-bag']" ></fa-icon>&nbsp;
        <span *ngIf="strViewType == 'edit'" >{{ 'edit_purchase_order'| translate }} </span>
        <span *ngIf="strViewType == 'add'">{{ 'create_purchase_order'| translate }} </span>
    </h3>
    <ng-container *fcHasPermission="'purchase_orders' + ((strViewType == 'add') ? ':create' : ':edit')">
      <div class="ml-auto d-flex">
        <ul class="list-inline pull-right">
          <li class="list-inline-item">
            <form-real-time-pdf-preview
              [disabled]="isPreviewTemplate || !bInvoiceLineLoaded || bSubmitted || (whenInProgress$ | async)"
              (click)="onPreview()"
              [trigger-event]="realTimePreviewTemplate.asObservable()"
              (onComplete)="whenInProgress$.next(false)">
            </form-real-time-pdf-preview>
          </li>
          <li class="list-inline-item">
            <form-templates-save-and-preview-btn
              [disabled]="isPreviewTemplate || !bInvoiceLineLoaded || bSubmitted || (whenInProgress$ | async)"
              (click)="onSubmitAndPreview()"
              [trigger-event]="previewTemplate.asObservable()">
            </form-templates-save-and-preview-btn>
          </li>
          <li class="list-inline-item">
            <button (click)="savePurchaseOrder()" class="btn btn-primary" [disabled]="bSubmitted || !bInvoiceLineLoaded || (whenInProgress$ | async)">
              <fa-icon *ngIf="!bSubmitted" [icon]="['fas', 'save']"></fa-icon>
              <fa-icon *ngIf="bSubmitted" [icon]="['fas', 'spinner']" [spin]="true" aria-hidden="true"></fa-icon>
              <span class="pl-1">{{ 'save' | translate }}</span>
            </button>
          </li>
          <li class="list-inline-item">
            <fieldmagic-primary-button
              [disabled]="bSubmitted || !bInvoiceLineLoaded || (whenInProgress$ | async)"
              (click)="cancelDialog()"
              variant="error"
              icon="times"
              label="close"
              id="exit-dialog"
            ></fieldmagic-primary-button>
          </li>
        </ul>
      </div>
    </ng-container>
  </div>
</header>

<hr class="separator"/>

<ng-container *fcHasPermission="'purchase_orders' + ((strViewType == 'add') ? ':create' : ':edit'); else createPODisabled">
<mat-dialog-content *ngIf="purchaseOrderForm" class="mobile-view-dialog">
<app-error-handler onlyFor="edit_form" [isAction]="true" alignment="center">
  <div *ngIf="purchaseOrderForm.length != 0" class="mt-3">
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li *ngFor="let item of purchaseOrderForm" class="nav-item text-size">
        <a class="nav-link" [ngClass]="{'active': purchaseOrderForm[0]['label'] == item.label}" id="{{item.label}}-tab" data-toggle="tab" href="#{{item.id}}" role="tab" aria-selected="true" translate>{{ item.label }}</a>
      </li>
    </ul>
    <div class="tab-content">
      <div *ngFor="let item of purchaseOrderForm" [ngClass]="{'active': purchaseOrderForm[0]['label'] == item.label, 'show': purchaseOrderForm[0]['label'] == item.label}" class="tab-pane row p-4" [id]="item.id" role="tabpanel">
        <fieldmagic-alert mode="info" *ngIf="strPurchasingNotes" class="w-100 text-left">
          <span>{{ strPurchasingNotes }}</span>
        </fieldmagic-alert>
        <form [formGroup]="item.groups">
          <div class="row">
            <ng-container *ngFor="let data of item.fields">
              <ng-container *ngIf="(( data.label != 'created_by' && data.label != 'modified_by' && data.label != 'updated_at' && data.label != 'created_at') && strViewType == 'add') || strViewType == 'edit'">
                <div *ngIf="data.key != 'line_items' else lineItems" class="col-{{data.space}} mb-3">
                  <app-edit-field [item]="data" [form]="item.groups" [bSubmitted]="bSubmitted" [strMode]="strViewType" strModule="purchase_orders" (parentEvent)="doSomethingInParent($event)" [strRecordId]="" (strCurrentValue)="getRelateText(data, $event)" (objCurrentValue)="getRelateObject($event)"></app-edit-field>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div align="center">
    <fa-icon *ngIf="purchaseOrderForm.length == 0" [icon]="['fas', 'spinner']" [spin]="true" class="loading-spinner" aria-hidden="true"></fa-icon>
  </div>
</app-error-handler>
</mat-dialog-content>

<ng-template #lineItems>
<!-- Flexible and Milestone Invoicing Field -->
<div class="col-12">
  <div class="row">
    <div class="col-6">
      <label class="labels">
        {{ 'line_items' | translate }}
      </label>
    </div>
    <div class="col-6">
      <button type="button" (click)="addLineItemFromWorkOrder()" class="btn btn-success pull-right mb-2">
          <fa-icon [icon]="['fas', 'plus']"></fa-icon> {{ 'add_from_work_order' | translate }}
        </button>
    </div>
    <div class="col-12 mb-2">
      <browse-products (objProductSelected)="addLineAttribute($event, true)" [bLabor]="false" [bSales]="false"></browse-products>
    </div>
    <div class="col-12">

      <div class="row">

        <div class="col-12">
          <div class="d-flex flex-row border">
            <div class="daggable-table-box-header" style="width: 8%"></div>
            <div class="draggable-table-box-header" [ngStyle]="{ width: bDepartmentTracking ? '17%' : '30%'}">
              <b>{{ 'description' | translate }}<required-tag></required-tag></b>
            </div>
            <div *ngIf="bDepartmentTracking" class="draggable-table-box-header" style="width: 12%">
              <b>{{ 'department' | translate }}<required-tag></required-tag></b>
            </div>
            <div class="draggable-table-box-header" style="width: 10%">
              <b>{{ 'quantity' | translate }}</b>
            </div>
            <div class="draggable-table-box-header" style="width: 10%">
              <b>{{ 'unit_cost' | translate }}</b>
            </div>
            <div class="draggable-table-box-header" style="width: 12%">
              <b>{{ 'tax_code' | translate }}<required-tag></required-tag></b>
            </div>
            <div class="draggable-table-box-header" style="width: 12%">
              <b>{{ 'account_code' | translate }}<required-tag></required-tag></b>
            </div>
            <div class="draggable-table-box-header" style="width: 10%">
              <b>{{ 'amount' | translate }}</b>
            </div>
            <div
              (mouseover)="iconDisplay.supplier_pricing=false"
              (mouseout)="iconDisplay.supplier_pricing=true"
              class="draggable-table-box-header pl-2"
              style="width: 3%">
              <fieldmagic-icon *ngIf="iconDisplay.supplier_pricing" icon="dollar-sign" customClass="pl-1"></fieldmagic-icon>
              <span *ngIf="!iconDisplay.supplier_pricing" class="pt-1">
                <input
                  type="checkbox"
                  [(ngModel)]="bUpdateAllUnitCost"
                  (change)="onChangeCheckbox($event, 'update_supplier_pricing')"
                  class="p-0 m-0"
                  style="height: 13px !important;"
                  matTooltip="{{ 'create_update_supplier_pricing' | translate }}" />
              </span>
            </div>
            <div
              (mouseover)="iconDisplay.product_supplier=false"
              (mouseout)="iconDisplay.product_supplier=true"
              class="draggable-table-box-header pl-1"
              style="width: 3%">
              <fieldmagic-icon *ngIf="iconDisplay.product_supplier" icon="user" customClass="pl-1"></fieldmagic-icon>
              <span *ngIf="!iconDisplay.product_supplier" class="pl-1 pt-1">
                <input
                  type="checkbox"
                  [(ngModel)]="bUpdateAllSupplier"
                  (change)="onChangeCheckbox($event, 'update_product_supplier'); onChangeSupplierCheckbox($event);"
                  class="p-0 m-0"
                  style="height: 13px !important;"
                  matTooltip="{{ 'update_product_preferred_supplier' | translate }}" />
              </span>
            </div>
            <div
              (mouseover)="iconDisplay.product_unit_cost=false"
              (mouseout)="iconDisplay.product_unit_cost=true"
              class="draggable-table-box-header pl-1"
              style="width: 3%">
              <fieldmagic-icon *ngIf="iconDisplay.product_unit_cost" icon="box-open" customClass="pl-1"></fieldmagic-icon>
              <span *ngIf="!iconDisplay.product_unit_cost" class="pl-1 pt-1">
                <input
                  type="checkbox"
                  [(ngModel)]="bUpdateAllProductUnitCost"
                  (change)="onChangeCheckbox($event, 'update_product_buy_price')"
                  class="p-0 m-0"
                  style="height: 13px !important;"
                  matTooltip="{{ 'update_product_buy_price' | translate }}" />
              </span>
            </div>
          </div>
        </div>

        <div *ngIf="bInvoiceLineLoaded" class="col-12">
          <div cdkDropList (cdkDropListDropped)="drop($event)" class="row">

            <ng-container *ngFor="let attr of arLineAttributes; index as i">
              <div cdkDrag class="col-12">
                <div
                  (click)="onLineFocus(i)"
                  class="d-flex flex-row border border-top-0 bg-white"
                  [ngClass]="{
                    'multiple-selected': contextMenuService.isLineItemSelected(attr, selectedLineItems),
                    'row-focused': (numLastFocusedLineIndex - 1) == i
                  }"
                >

                  <div class="draggable-table-box center-items pr-2 pl-2" style="width: 2%;"
                    [shAttachMenu]="contextMenuComponent?.menu"
                    [shMenuData]="contextMenuService.formatMenuData(attr, i)"
                    (click)="onClickedLineItem($event, attr)"
                    matTooltip="{{ 'copy_paste_info' | translate }}"
                    matTooltipPosition="right"
                  >
                    <fa-icon
                      cdkDragHandle
                      style="cursor: grab;"
                      [icon]="['fas', 'grip-vertical']">
                    </fa-icon>
                  </div>

                  <div class="draggable-table-box center-items" style="width: 6%;"
                    [shAttachMenu]="contextMenuComponent?.menu"
                    [shMenuData]="contextMenuService.formatMenuData(attr, i)"
                    (click)="onClickedLineItem($event, attr)"
                    matTooltip="{{ 'copy_paste_info' | translate }}"
                    matTooltipPosition="right"
                  >

                    <fa-icon *ngIf="arLineAttributes.length > 1" (click)="removeAttribute(attr)"
                      class="pl-1 pr-1 pb-2 pt-2 text-danger pointer"
                      [icon]="['fal', 'minus-circle']">
                    </fa-icon>

                    <a *ngIf="attr['purchase_order']['item_id']"
                      href="/#/items/{{ attr['purchase_order']['item_id'] }}"
                      class="pl-1 pr-1 pb-2 pt-2"
                      target="_blank">
                      <fa-icon
                        matTooltipClass="tooltip-space"
                        matTooltip="
                        {{ 'click_to_view' | translate }}&#13;&#13;
                        {{ 'product' | translate }}: {{ attr['item']['text'] }}&#13;
                        {{ 'code' | translate }}: {{ attr['purchase_order']['item_code'] | placeholdWithString }}&#13;
                        {{ 'preferred_supplier' | translate }}: {{ attr['purchase_order']['preferred_supplier_text'] | placeholdWithString }}&#13;
                        {{ 'current_stock_level' | translate }}: {{ attr['current_stock_level'] }}&#13;
                        {{ 'supplier_notes' | translate }}: {{ getNotesOfSupplier(attr['supplier_info'], attr) | placeholdWithString }}"
                        class="text-primary"
                        [icon]="['fas', 'info-circle']">
                      </fa-icon>
                    </a>

                    <fa-icon *ngIf="attr['purchase_order']['item_id']"
                      [icon]="['fas', 'chart-line']"
                      class="text-primary desktop-container pointer pl-1 pr-1 pb-2 pt-2"
                      matTooltip="{{ 'show_stock_levels_and_supplier_pricing' | translate }}"
                      (click)="openSupplierInventoryDialog(attr['purchase_order']['item_id'])"
                    >
                    </fa-icon>

                    <fa-icon
                      *ngIf="!attr['purchase_order']['item_id']"
                      class="pl-1 pr-1 pb-2 pt-2 text-success pointer"
                      matTooltip="{{ 'create_item' | translate }}"
                      [icon]="['fas', 'plus-circle']"
                      (click)="createItem(attr)">
                    </fa-icon>

                    <fa-icon
                      *ngIf="attr.related_products.length > 0"
                      matTooltip="{{ 'add_related_products' | translate }}"
                      class="pl-1 pr-1 pb-2 pt-2 pointer text-success"
                      [icon]="['fas', 'plus-circle']"
                      (click)="addRelated(attr, i)">
                    </fa-icon>

                    <fa-icon
                      [popover]="selectRelateJob"
                      containerClass="m-2"
                      [outsideClick]="true"
                      placement="top"
                      triggers="click:click"
                      [matTooltip]="(attr['purchase_order']['job_id'] | blank) ? ('select_job_to_relate_on_line_item' | translate) : ('%s: #%s' | sprintf: ['selected_job_number' | translate, attr['job_data']['job_number']])"
                      class="pl-1 pr-1 pb-2 pt-2 pointer"
                      [icon]="['fas','briefcase']"
                      [class.text-success]="(attr['purchase_order']['job_id'] | filled) && (attr['job_data'] | filled)"
                      [class.text-secondary]="attr | data_get: 'purchase_order.job_id' | blank"
                    >
                    </fa-icon>

                    <ng-template #selectRelateJob>
                      <div
                        class="d-flex d-flex-gap flex-column"
                        style="width: 200px;"
                      >
                        <div id="job">
                          <fieldmagic-relate-input
                            label="select_job"
                            moduleName="jobs"
                            (change)="selectJob($event, attr, i)"
                            [(ngModel)]="attr['job_data']"
                            placeholder="select_job"
                          >
                          </fieldmagic-relate-input>
                        </div>

                        <div
                          *ngIf="attr | data_get: 'job_data.enable_cost_centers'"
                          id="cost_centers"
                        >
                          <fieldmagic-relate-input
                            label="Select a task"
                            [(ngModel)]="attr['job_task_id']"
                            moduleName="job_tasks"
                            [filter]="{
                              job_id: attr | data_get: 'job_data.id'
                            }"
                            (ngModelChange)="onSelectTask(attr, i)"
                            placeholder="select_task"
                          >
                          </fieldmagic-relate-input>
                        </div>
                      </div>
                    </ng-template>

                  </div>
                  <div class="draggable-table-box" [ngStyle]="{ width: bDepartmentTracking ? '17%' : '30%'}">
                    <textarea
                      class="form-control po-task-desc-{{i}}" style="font-size: 12px;"
                      placeholder="{{ 'description' | translate }}"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="attr['purchase_order']['description']"
                      [ngClass]="{'is-invalid': (validateField(attr['purchase_order']['description'])) && isTouched}"
                      (focus)="increaseRow(i)"
                      (focusout)="decreaseRow(i)"
                      (ngModelChange)="markAsDirty()"
                      #invoiceLineDesc>
                    </textarea>
                  </div>
                  <div *ngIf="bDepartmentTracking" class="draggable-table-box" style="width: 12%">
                    <fieldmagic-relate-input
                      moduleName="departments"
                      [(ngModel)]="attr['department']"
                      (change)="selectDepartment($event, attr)"
                      [errorneous]="validateField(attr['purchase_order']['department_id']) && isTouched"
                      placeholder="select_department"
                    ></fieldmagic-relate-input>
                  </div>
                  <div class="draggable-table-box" style="width: 10%">
                    <fieldmagic-decimal-input
                      customClass="form-control font-size-12 input-height-40"
                      (change)="quantityChange($event, attr)"
                      placeholder="{{ 'quantity' |  translate }}"
                      style="font-size: 12px;"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="attr['purchase_order']['quantity']"
                      disableScroll>
                    </fieldmagic-decimal-input>
                  </div>
                  <div class="draggable-table-box" style="width: 10%">
                    <fc-currency-input
                      [places]="4"
                      id="unit_cost_{{ i }}"
                      [(ngModel)]="attr['purchase_order']['unit_cost']"
                      [ngModelOptions]="{standalone: true}"
                      [customClass]="'form-control font-size-12 input-height-40'"
                      (change)="unitCostChange($event, attr)"
                      decimalPipe
                      disableScroll>
                    </fc-currency-input>
                  </div>
                  <div class="draggable-table-box" style="width: 12%">
                    <fieldmagic-relate-input
                      moduleName="tax_codes"
                      [filter]="arTaxCodeFilter"
                      [(ngModel)]="attr['tax']"
                      (change)="selectATaxcode($event, attr)"
                      [errorneous]="(validateField(attr['purchase_order']['tax_code_id']) || attr['tax'] == null) && isTouched"
                      placeholder="tax_code"
                    ></fieldmagic-relate-input>
                  </div>
                  <div class="draggable-table-box" style="width: 12%">
                    <fieldmagic-relate-input
                      moduleName="account_codes"
                      [filter]="arAccountCodeFilter"
                      [(ngModel)]="attr['account_code']"
                      (change)="selectAccountCode($event, attr)"
                      [errorneous]="(validateField(attr['purchase_order']['account_code_id']) || attr['account_code'] == null) && isTouched"
                      placeholder="account_code"
                    ></fieldmagic-relate-input>
                  </div>
                  <div class="draggable-table-box" style="width: 10%">
                    <fc-currency-input
                      customClass="form-control font-size-12 input-height-40"
                      [(ngModel)]="attr['amount']"
                      (change)="onLineTotalChange($event.target, {attr: attr, index: i})"
                      disableScroll
                    ></fc-currency-input>
                  </div>
                  <div class="draggable-table-box p-2" style="width: 3%">
                    <input
                      type="checkbox"
                      [checked]="attr.update_supplier_pricing"
                      matTooltip="{{ 'create_update_supplier_pricing' | translate }}"
                      (change)="onChangeCheckbox($event, 'update_supplier_pricing', attr, false)"
                      [disabled]="!attr['purchase_order']['item_id']"
                    />
                  </div>
                  <div class="draggable-table-box p-2" style="width: 3%">
                    <input
                      type="checkbox"
                      [checked]="attr.update_product_supplier"
                      matTooltip="{{ 'update_product_preferred_supplier' | translate }}"
                      (change)="onChangeCheckbox($event, 'update_product_supplier', attr, false); onChangeSupplierCheckbox($event, attr, false);"
                      [disabled]="!attr['purchase_order']['item_id']"
                    />
                  </div>
                  <div class="draggable-table-box p-2" style="width: 3%">
                    <input
                      type="checkbox"
                      [checked]="attr.update_product_buy_price"
                      matTooltip="{{ 'update_product_buy_price' | translate }}"
                      (change)="onChangeCheckbox($event, 'update_product_buy_price', attr, false)"
                      [disabled]="!attr['purchase_order']['item_id']"
                    />
                  </div>
                </div>
              </div>
            </ng-container>

            <div class="col-12 text-center" *ngIf="arLineAttributes.length < 1" [shAttachMenu]="contextMenuComponent?.menu" [shMenuData]="contextMenuService.formatMenuData([], -1)">
              <div class="d-flex flex-row border border-top-0 bg-white">
                <div class="draggable-table-box center-items pr-2 pl-2" style="width: 100%">
                  <span>{{ 'no_invoice_line' | translate }}</span>
                </div>
              </div>
            </div>

            <div *ngIf="!bInvoiceLineLoaded" class="col-12 text-center" style="font-size: 16px;">
              <fa-icon [icon]="['fas', 'spinner']" [spin]="true" aria-hidden="true"></fa-icon>
            </div>

          </div>
        </div>

      </div>

      <div *ngIf="bInvoiceLineLoaded" class="row">
        <div class="col-12">
          <div class="d-flex flex-row border border-top-0">
            <div class="draggable-table-box right-items" style="width: 90%;">
              <span class="p-2">{{ 'total_ex_tax' | translate }}</span>
            </div>
            <div class="draggable-table-box left-items" style="width: 10%;">
              <span class="ml-2">{{ computeInvoiceLineExcludedTax() | currency: {decimal_places: 2} }}</span>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="d-flex flex-row border border-top-0">
            <div class="draggable-table-box right-items" style="width: 90%;">
              <span class="p-2  float-right">{{ 'tax' | translate }}</span>
            </div>
            <div class="draggable-table-box left-items" style="width: 10%;">
              <span class="ml-2">{{ computeInvoiceLineTax() | currency: {decimal_places: 2} }}</span>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="d-flex flex-row border border-top-0">
            <div class="draggable-table-box right-items" style="width: 90%;">
              <span class="p-2 float-right">{{ 'tax_adjustment_amount' | translate }}</span>
            </div>
            <div class="draggable-table-box center-items" style="width: 10%;">
              <fc-currency-input
                step="0.01"
                [withControls]="true"
                customClass="form-control font-size-12 input-height-40"
                [(ngModel)]="totalTaxAdjustment"
                (change)="onTaxAdjustment()"
                disableScroll>
              </fc-currency-input>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="d-flex flex-row border border-top-0">
            <div class="draggable-table-box right-items" style="width: 90%;">
              <span class="p-2  float-right">{{ 'total_inc_tax' | translate }}</span>
            </div>
            <div class="draggable-table-box center-items" style="width: 10%;">
              <fc-currency-input
                id="invoiceLineIncludedTaxField"
                [(ngModel)]="invoiceLineIncludedTax"
                customClass="form-control input-height-40 font-size-12"
                disableScroll>
              </fc-currency-input>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</ng-template>
</ng-container>

<ng-template #createPODisabled>
  <span id="btnCreatePODisabled" class="disabled"
    matTooltip="{{ 'forbidden_action_error' | translate }}">
    {{ 'forbidden_action_error' | translate }}
  </span>
</ng-template>

<fc-context-menu (isClicked)="doSomethingFromContextMenu($event)"></fc-context-menu>
